export const cancellationReasons = [
  { id: 'noNeeded', label: 'No longer needed' },
  { id: 'noShow', label: 'No show' },
  { id: 'sick', label: 'Sick' },
  { id: 'emergency', label: 'Emergency' },
  { id: 'custom', label: 'Custom' },
];
